import React from 'react';
import { connect } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import {
    CalibrationId,
    CalibrationFanSpeed
} from 'services/equipmentSets/types';
import { createStructuredSelector } from 'reselect';
import { WorksheetPageIndex } from 'services/worksheet/types';
import { makeSelectFanSpeed } from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    calibrationId: CalibrationId;
}

interface ConnectedProps {
    fanSpeed: CalibrationFanSpeed;
}

type Props = OwnProps & ConnectedProps;

export class FanSpeedTableCellComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { fanSpeed } = this.props;

        return <TableCell>{fanSpeed}</TableCell>;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    fanSpeed: makeSelectFanSpeed()
});

export default connect(mapStateToProps)(FanSpeedTableCellComponent);
